import { createFileRoute, redirect } from '@tanstack/react-router'

// Models is now a public page at /models — this redirect only exists for
// old bookmarks/links to this dashboard-scoped path. Server-side redirect()
// (not a client-only <Navigate>) so it resolves before any HTML is sent.
export const Route = createFileRoute('/dashboard/models')({
  head: () => ({
    meta: [{ name: 'robots', content: 'noindex, nofollow' }],
  }),
  beforeLoad: () => {
    throw redirect({ to: '/models' })
  },
})
